export default {
      id: "Icon--rare-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--rare",
      toString: function () {
        return this.url;
      }
    }